









































import { Vue, Component } from 'vue-property-decorator';
import HomeMcpDetailsModal from './home-mcp-details-modal.component.vue';

@Component({
  components: {
    HomeMcpDetailsModal,
  },
})
export default class HomeMcpAnnouncement extends Vue {
  visible: boolean = true;

  showDetails: boolean = false;

  close() {
    this.visible = false;
  }

  openDetails() {
    this.showDetails = true;
  }

  closeDetails() {
    this.showDetails = false;
  }
}
